module.exports = __webpack_public_path__ + "img/assets.a65d2c7d.svg";